<template>
  <div>
    <template v-if="loading">
      Validating..
    </template>

    <template v-else>
      You have been un-subscribed. Thank you.
    </template>
  </div>
</template>

<script>
  import { EventBus } from '@/shared/event-bus'
  
  export default {

    data () {
      return {
        loading : false,
        broker  : null,
        settings: null
      }
    },

    created() {
      this.loading = true
      this.apiPost({
        key     : this.$route.params.key,
        brokerId: this.$route.params.brokerId
      }, 'broker/check-unsubscribe-key', (result) => {
        if(parseInt(result) == 1) {
          this.apiPost({
            key     : this.$route.params.key,
            brokerId: this.$route.params.brokerId
          }, 'broker/unsubscribe-report', () => {
            this.loading = false
          })
        }
      })
    },
  }
</script>